import { useController } from "react-hook-form";
import { Select } from "../../../../../../../Inputs";
import { useBuilderFormContext, useBuilderWatch } from "../../../form/form";
import type { InputSettingsFormProps } from "../FieldSettingsView";
import type { UnitsOptions } from "./types";
import {
  getUnitsDefaultValuePaths,
  getUnitsOptionsPath,
  unitsOptionsToDropdownOptions,
} from "./utils";

export function UnitsStaticDefaultInput({
  fieldPath,
  isReadOnly,
}: Pick<InputSettingsFormProps, "fieldPath" | "isReadOnly">) {
  const { setValue } = useBuilderFormContext();

  const [unitsDefaultValuePath, unitsBuilderDefaultValuePath] =
    getUnitsDefaultValuePaths(fieldPath);

  const { field } = useController({ name: unitsDefaultValuePath });

  const unitsOptions = useBuilderWatch(getUnitsOptionsPath(fieldPath)) as
    | UnitsOptions
    | undefined;

  const dropdownOptions =
    unitsOptions ? unitsOptionsToDropdownOptions(unitsOptions) : [];

  return (
    <Select
      label="Units default value"
      name={unitsDefaultValuePath}
      value={field.value}
      onChange={value => {
        // store no value (undefined) instead of empty string in form state,
        // updating both default value locations in sync
        field.onChange(value ?? undefined);
        setValue(unitsBuilderDefaultValuePath, value ?? undefined, {
          shouldValidate: true,
          shouldDirty: true,
        });
      }}
      options={dropdownOptions}
      isClearable
      disabled={isReadOnly}
    />
  );
}
